<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row justify-content-lg-between align-items-lg-center text-center text-md-start mt-3 mt-md-0" :style="{ 'flex-direction': BlockProps.Flipped ? 'row-reverse' : 'row' }">
                        <div class="col-lg-5 mb-9 mb-lg-0">
                            <div class="mb-6">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Title" tag-name="h2">
                                </omnieditor>
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Content" tag-name="p">
                                </omnieditor>
                            </div>

                            <!-- Blockquote -->
                            <figure>
                                <blockquote class="blockquote">
                                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Quote" tag-name="span">
                                    </omnieditor>
                                </blockquote>

                                <figcaption class="blockquote-footer">
                                    <div class="d-flex align-items-center">

                                        <div class="flex-grow-1 ms-3">
                                            <span class="blockquote-footer-source">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Footer" tag-name="span">
                                                </omnieditor>
                                            </span>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                            <!-- End Blockquote -->
                        </div>
                        <!-- End Col -->

                        <div class="col-lg-6">
                            <!-- List -->
                            <ul class="list-equal-height list-equal-height-2-cols">
                                <li v-for="(card, index)  in BlockProps.Cards" :key="card" class="list-equal-height-item" v-bind:style="CardBGColor(index)">
                                    <h4 class="display-7"><propertyiconeditor v-if="card.Icon" :blockprops="BlockProps" :inline="true" v-model:icon="card.Icon" :prompt="'Card Icon (click to change)'"></propertyiconeditor>&nbsp;<omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="card.Header" tag-name="span"></omnieditor></h4>
                                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="card.Content" tag-name="p" class="mb-0">
                                    </omnieditor>
                                </li>
                            </ul>
                            <!-- End List -->
                        </div>
                        <!-- End Col -->
                    </div>
                    <!-- End Row -->
                </div>

            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="Shadows" :blockprops="BlockProps" prompt="Inner Drop Shadows"></propertytogglededitor>

                        <div>
                            <div class="row">
                                <div class="col col-12">
                                    <label for="customRange2" class="form-label">Number of Cards (1 - 6)</label>
                                    <div class="input-group mb-3">
                                        <button @click="RemoveCard" class="btn btn-outline-secondary" type="button">-</button>
                                        <input readonly style="text-align:center;" min="1" max="6" type="number" class="form-control" v-model="NumCardsUI">
                                        <button @click="AddCard" class="btn btn-outline-secondary" type="button">+</button>
                                    </div>
                                    <div class="progress" style="height: 20px;">
                                        <div class="progress-bar" role="progressbar" :style="{'width': NumCardsUIFilled}" :aria-valuenow="NumCardsUIFilled" aria-valuemin="0" aria-valuemax="6">{{NumCardsUI}} / 6</div>
                                    </div>
                                </div>
                                <hr style="margin-top: 10px; margin-bottom:5px;" />
                            </div>

                            <propertytogglededitor propertyname="Flipped" :blockprops="BlockProps" prompt="Flip Layout"></propertytogglededitor>

                            <propertycoloreditor :propertyname="'HighlightColor'" :blockprops="BlockProps" :prompt="'Highlight Color'"></propertycoloreditor>
                            <propertycoloreditor :propertyname="'CardHighlightColor'" :blockprops="BlockProps" :prompt="'Card Highlight Color'"></propertycoloreditor>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    import Editor from '@tinymce/tinymce-vue'

    // Swiper components


    export default {
        inheritAttrs: false,
        name: 'CardsTwo',
        mixins: [ContentBlockBase],
        props: [],
        components: {
            'editor': Editor,

        },
        computed:
        {
            NumCardsUIFilled(){
                return `${Math.floor(this.NumCardsUI / 6 * 100)}%`;
            },            
        },
        watch: {
            'BlockProps.Cards.length': {
                handler(newVal, oldVal) {
                    // Update the last card index whenever BlockProps.Cards changes
                    this.LastCardIndex = newVal - 1;
                },
                immediate: true, // Trigger the handler immediately on component creation
            },
            NumCardsUI: function (newVal, oldVal) {
                
                while (newVal < this.BlockProps.Cards.length) {
                    this.BlockProps.Cards.pop();
                }

                while (newVal > this.BlockProps.Cards.length) {
                    var newCard = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Cards[0]);
                    newCard = JSON.parse(newCard)
                    this.BlockProps.Cards.push(newCard);
                }
           
            }
        },
        data() {
            return {  
                NumCardsUI: 4,
                LastCardIndex: 0
            };
        },
        methods:
        {       
            CardBGColor(index) {
                const isLast = index === this.LastCardIndex;
                var bgc = isLast ? this.BlockProps.HighlightColor : 'none !important';
                var css = {
                    'backgroundColor': bgc + " !important"
                };
                
                return css;
            },
            AddCard: function () {
                this.NumCardsUI = Math.min(this.NumCardsUI + 1, 6);             
            },
            RemoveCard: function () {
                this.NumCardsUI = Math.max(this.NumCardsUI - 1, 1);
            },
            OnSlideBackgroundUploaded: function (args) {
                if(args.success){
                    if(args.idx >= this.BlockProps.Slides.length){
                        return;
                    }
                    if(args.url){
                        this.BlockProps.Slides[args.idx].img = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            this.NumCardsUI = this.BlockProps?.Cards.length ?? 0;
            nextTick().then(() => {
     
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .ce-block .ce-block--focused {
        border: 1px dashed #cbcbcb !important
    }
    #editorjs {
        color: green;
    }

    .mce-content-body [data-mce-selected=inline-boundary] {
        background-color: unset !important;
    }

    .card:hover {
        box-shadow: 0 1rem 1.75rem 0 rgba(45,55,75,.1);
    }
</style>

